<template>
  <div>
    <div class="form-row">
      <div
        class="col-12 d-flex align-items-center flex-wrap mb-3 flex-column flex-sm-row text-center"
      >
        <h5 class="">* FORMAÇÕES</h5>

        <button
          type="button"
          class="btn btn-dark ml-0 ml-sm-auto"
          v-if="
            educations.length > 0 ||
            format == 'modal-form' ||
            !$store.getters.basicProfileEmpty ||
            ($route.name != 'deixe-seu-perfil' &&
              $route.name != 'atualizacao-perfil')
          "
          @click="edit(null)"
        >
          Adicionar Formação
        </button>
      </div>

      <div
        class="col-12 mb-4"
        v-for="(education, index) in educations"
        :key="index"
      >
        <div
          class="d-flex align-items-center justify-content-between justify-content-md-start"
        >
          <div class="mr-3" v-if="education.institutionName">
            <h5 class="mb-0">{{ education.institutionName }}</h5>
            <p class="mb-0">
              {{
                $store.state.domains.education_levels.find(
                  (edL) => edL.id == education.level
                )["description"]
              }}<span v-if="education.courseName">,</span>
              {{ education.courseName }}
            </p>
          </div>
          <div class="mr-3" v-else>
            <h5 class="mb-0">
              {{
                $store.state.domains.education_levels.find(
                  (edL) => edL.id == education.level
                )["description"]
              }}
            </h5>
          </div>

          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-light"
              @click="edit(education)"
            >
              <pencil-icon class="align-text-bottom" />
            </button>
            <button
              type="button"
              class="btn btn-light"
              @click="remove(education.id)"
            >
              <delete-icon class="align-text-bottom" />
            </button>
          </div>
        </div>

        <div
          class="d-flex mt-2"
          v-if="education.startDate || education.endDate"
        >
          <div v-if="education.startDate">
            <h6 class="semi-small m-0">Início</h6>
            <span>{{ $moment(education.startDate).format("YYYY") }}</span>
          </div>

          <div v-if="education.startDate && education.endDate" class="px-1">
            <h6 class="semi-small m-0">/</h6>
            <span>-</span>
          </div>

          <div v-if="education.endDate">
            <h6 class="semi-small m-0">Conclusão</h6>
            <span>
              {{
                $moment(education.endDate).isAfter()
                  ? " (Previsão de término em " +
                    $moment(education.endDate).format("YYYY") +
                    ")"
                  : $moment(education.endDate).format("YYYY")
              }}
            </span>
          </div>
        </div>

        <!-- <p class="text-muted" v-if="education.startDate || education.endDate">
          <span v-if="education.startDate">{{ $moment(education.startDate).format('YYYY') }} -</span>
          <span v-if="education.endDate">
            {{
              $moment(education.endDate).isAfter() ?
              ' (Previsão de término em ' + $moment(education.endDate).format('YYYY') + ')' :
              $moment(education.endDate).format('YYYY')
            }}
          </span>
        </p> -->
      </div>
    </div>

    <b-modal
      ref="modal-education"
      size="lg"
      centered
      :hide-header="true"
      :hide-footer="true"
      no-close-on-backdrop
      lazy
    >
      <div class="py-4 px-2 px-lg-4">
        <h4 class="mb-4">FORMAÇÃO</h4>

        <button
          type="button"
          class="ml-auto close"
          @click="$refs['modal-education'].hide()"
        >
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <FormEducation
          @closeModal="$refs['modal-education'].hide()"
          hasButtons
        />
      </div>
    </b-modal>

    <div
      v-if="
        format == 'inline-form' &&
        (educations.length == 0 || $route.name == 'atualizacao-perfil') &&
        $store.getters.basicProfileEmpty &&
        ($route.name == 'deixe-seu-perfil' ||
          $route.name == 'atualizacao-perfil')
      "
    >
      <div
        class="form-area mb-5"
        :class="{ 'has-multiple': formsIds.length > 1 }"
        v-for="(item, index) in formsIds"
        :key="index"
      >
        <FormEducation
          storeByEventBus
          :rawData="
           $store.state.user.profileExternalBase && $store.state.user.profileExternalBase.educations.length >= index - 1
              ? $store.state.user.profileExternalBase.educations[index]
              : null
          "
        />
        <div class="d-flex" v-if="formsIds.length > 1">
          <button
            class="btn btn-link btn-lg p-0 ml-auto"
            @click="removeForm(item)"
          >
            <u>Remover Formação</u>
          </button>
        </div>
      </div>

      <div class="d-flex">
        <button class="btn btn-lg mx-auto" @click="addForm()">
          Adicionar Formação
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import FormEducation from "./FormEducation.vue";

export default {
  name: "BoxEducation",

  data() {
    return {
      formsIds: this.$store.state.user.profileExternalBase
        ? this.$store.state.user.profileExternalBase.educations
        : [new Date().getTime()],
    };
  },

  computed: {
    educations() {
      const user = this.$store.state.user;
      if (user.profile) {
        return user.profile.educations
          ? this.$helpers.sortBy(user.profile.educations, "endDate", "desc")
          : [];
      } else {
        return [];
      }
    },
  },

  props: {
    format: {
      type: String,
      default: "inline-form",
    },
  },

  components: {
    CloseIcon,
    PencilIcon,
    DeleteIcon,
    FormEducation,
  },

  methods: {
    addForm() {
      this.formsIds.push(new Date().getTime());
    },

    removeForm(item) {
      this.$swal({
        title: "Atenção",
        text: "Tem certeza que deseja remover a Formação?",
        type: "error",
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim, desejo remover",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.formsIds = this.formsIds.filter((form) => form !== item);
        }
      });
    },

    edit(education) {
      this.$refs["modal-education"].show();
      setTimeout(
        () => this.$EventBus.$emit("editingEducation", education),
        100
      );
    },

    remove(id) {
      if (!id) return;

      this.$swal({
        title: "Atenção",
        text: "Tem certeza que deseja remover a Formação?",
        type: "error",
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim, desejo remover",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("user/educationDelete", { id: id });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>